'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$$anon$51(evaluator$33) {
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$51__f_evaluator$9 = null;
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$51__f_evaluator$9 = evaluator$33;
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$$anon$51 as $c_Lapp_api_GeneralPracticeAppUpdate$$anon$51 };
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$51.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$51.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$51;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$$anon$51() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$$anon$51 as $h_Lapp_api_GeneralPracticeAppUpdate$$anon$51 };
$h_Lapp_api_GeneralPracticeAppUpdate$$anon$51.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$51.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$51.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$51.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_GeneralPracticeAppUpdate$$anon$51__f_evaluator$9.apply__O();
  return ((v !== null) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$51.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_GeneralPracticeAppUpdate$$anon$51 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$$anon$51, "app.api.GeneralPracticeAppUpdate$$anon$51", ({
  Lapp_api_GeneralPracticeAppUpdate$$anon$51: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$$anon$51 as $d_Lapp_api_GeneralPracticeAppUpdate$$anon$51 };
//# sourceMappingURL=app.api.-General-Practice-App-Update$$anon$51.js.map
